import React, { useEffect, useState } from "react";
import HeadingSample from "../components/utility/headingSample";
import { motion } from "framer-motion";
import PresaleOverview from "../components/presale_Token/presale_Overview";
import { db } from "../components/firebase/firebase";
import { getDocs, query, collection, orderBy } from "firebase/firestore";
const sec1Subtitle = "Get token in advance";
const sec1Title = ["presale token", "#F8D835"];

const Presale_Token: React.FC = () => {
  const [saftUrl, setSaftUrl] = useState("");
  useEffect(() => {
    const fetchURL = async () => {
      const q = query(collection(db, "saft_contracts"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const latest = snapshot.docs[0]?.data();
      if (latest?.url) {
        setSaftUrl(latest.url);
      }
    };
    fetchURL();
  }, []);
  return (
    <div className="w-full flex flex-col items-center justify-center bg-white box-border overflow-hidden">

      <motion.div
        id="presale_home"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="h-[500px] sm:h-[700px] w-full bg-[url('../public/presale_Token/section1.svg')] bg-black/30 bg-blend-overlay bg-cover bg-center"
      >
        <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
      </motion.div>
      <PresaleOverview />
      <div className="w-full bg-gradient-to-b from-[#1C1E2A] via-slate-400 to-[#1e1a3a]">
        <div className="  text-white p-4 sm:p-8 rounded-2xl shadow-xl w-full max-w-7xl mx-auto font-sans">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold mb-2 text-white">Mineralex Token Presale</h2>
            <p className="text-lg text-white">
              Secure Your Stake in the Future of Mineral Intelligence
            </p>
            <p className="text-lg text-gray-300">
              Join Mineralex's exclusive SAFT-based presale and be part of the next generation of decentralized mineral exploration.
            </p>

          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-10">
            <div className="bg-[#1a1837] p-6 rounded-xl">
              <h3 className="text-xl font-semibold text-white mb-4">Mineralex Rounds Plan</h3>
              <table className="w-full text-sm text-left">
                <thead>
                  <tr className="text-gray-400">
                    <th className="pb-2">Stage</th>
                    <th className="pb-2">Price</th>
                    <th className="pb-2">Target</th>
                    <th className="pb-2">Total MXUT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-gray-700">
                    <td className="py-2">Private Round - SAFT</td>
                    <td>$0.005</td>
                    <td>$300K</td>
                    <td>80,000,000</td>
                  </tr>
                  <tr className="border-t border-gray-700">
                    <td className="py-2">Seed Round</td>
                    <td>$0.01</td>
                    <td>$3.5M</td>
                    <td>350,000,000</td>
                  </tr>
                  <tr className="border-t border-gray-700">
                    <td className="py-2">Public Sale</td>
                    <td>$0.05</td>
                    <td>$10M–$20M</td>
                    <td>400,000,000</td>
                  </tr>
                </tbody>
              </table>
              <div className="text-sm text-white mt-4">
                Note: This presale is conducted under a Simple Agreement for Future Tokens (SAFT) framework, ensuring compliance with relevant securities regulations.
              </div>
            </div>

            <div className="bg-[#1a1837] p-6 rounded-xl">
              <h3 className="text-xl font-semibold text-white mb-4">Presale Details</h3>
              <ul className="text-sm text-gray-300 space-y-2">
                <li><strong>Token Name:</strong> Mineralex Token (MXUT)</li>
                <li><strong>Presale Price:</strong> 1 MXUT = $0.005</li>
                <li><strong>Total Supply:</strong> 1,000,000,000 MXUT</li>
                <li><strong>Available in Presale:</strong> 80,000,000 MXUT</li>
                <li><strong>Minimum Investment:</strong> $500</li>
                <li><strong>Accepted Currencies:</strong> ETH, USDT, BTC</li>
                <li><strong>Presale Period:</strong> June 20 – July 30, 2025</li>
              </ul>
            </div>
          </div>

          <div className="bg-[#1a1837] p-6 rounded-xl mb-10">
            <h3 className="text-xl font-semibold text-white mb-4">SAFT Framework: Investing with Confidence</h3>
            <p className="text-gray-300 text-sm sm:text-base mb-4">
              The SAFT framework provides a compliant and secure method for participating in token presales. By entering into a SAFT, accredited investors can fund the development of the Mineralex platform in exchange for future tokens, aligning incentives and ensuring regulatory compliance.
            </p>
            {saftUrl ? (
              <a
                href={saftUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500 transition"
              >
                Download SAFT Agreement
              </a>
            ) : (
              <p>SAFT Agreement file doesn't exist!</p>
            )}
          </div>

          <div className="bg-[#1a1837] p-6 rounded-xl">
            <h3 className="text-xl font-semibold text-white">Use of Funds</h3>
            <div className="text-base p-2">Your investment will directly contribute to:</div>
            <ul className="list-disc list-inside text-sm sm:text-base text-gray-300 space-y-2">
              <li><span className="font-bold">Legal Structure & Licensing:</span> Establishing the Mineralex parent company in an optimal jurisdiction and obtaining necessary licenses aligned with Mica regulations.</li>
              <li><span className="font-bold">Platform Development:</span> Enhancing blockchain infrastructure and user interfaces.</li>
              <li><span className="font-bold">Mineralex SL Geological Data & Licenses:</span> Expanding our mineral databases and extending exploration licenses.</li>
              <li><span className="font-bold">Regulatory Compliance:</span> Adhering to international mining and securities regulations.</li>
              <li><span className="font-bold">Marketing & Partnerships:</span> Building strategic alliances and growing the community.</li>
            </ul>
          </div>

          <div className="bg-[#1a1837] p-6 rounded-xl mt-8">
            <h3 className="text-xl font-semibold text-white">We prioritize investor security and strict regulatory compliance.</h3>
            <div className="text-base p-2">Secure your MXUT tokens today and join the future of mineral exploration.</div>
          </div>

          <div className="text-center mt-10">
            <button className="px-8 py-4 bg-gradient-to-r from-purple-500 to-orange-400 rounded-full text-white text-lg font-semibold hover:scale-105 transition">
              Participate in the Presale Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Presale_Token;
